export default {"src":"/_next/static/media/assistant-fixer-with-green-text-box.d0094fad.svg","height":332,"width":269};